import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  linkText?: string;
  linkPath?: string;
  id?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  linkText,
  linkPath,
  id,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 text-xs font-label uppercase tracking-[0.22em] text-primary-600">
            <span className="h-px w-6 bg-primary-500"></span>
            {eyebrow}
          </p>
        )}
        <h2 id={id} className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{desc}</p>}
      </div>
      {linkText && linkPath && (
        <Link
          to={linkPath}
          className="inline-flex shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
        >
          {linkText}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}